import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import Header from "../../../../components/Header";
function Config() {
  const [email, setEmail] = useState("");
  const [sendEmailUrl, setSendEmailUrl] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [emailError, setEmailError] = useState('');
  const [website, setwebsite] = useState('');
  const [emsUrl, setEmsUrl] = useState("");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-config`);
        const data = await res.json();
        if (res.ok) {
          setEmail(data.email || "");
          setSendEmailUrl(data.sendEmailUrl || "");
          setwebsite(data.website || "");
          setEmsUrl(data.emsUrl || "");
        }
      } catch (err) {
        console.error("Error fetching config:", err);
      }
    };
    fetchConfig();
  }, []);


  const handleSave = async () => {
    setEmailError('');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setEmailError("Email is required.");
      return;
    } else if (!emailRegex.test(email)) {
      setEmailError("Enter a valid email address.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/set-config`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          sendEmailUrl,
          website,
          emsUrl,
        })
      });

      const data = await response.json();

      if (response.ok) {
        setStatusMessage("Email saved successfully.");
      } else {
        setStatusMessage(data.error || "Failed to save credentials.");
      }
    } catch (error) {
      setStatusMessage("Error: " + error.message);
    }
  };

  return (
    <Box m="20px">
      <Header title="Configuration" subtitle="Set up application preferences" />
      <Box
        sx={{
          padding: 4,
          maxWidth: 600,
          margin: "auto",
          border: "1px solid #ccc",
          mt: 5,
          borderRadius: "22px",
        }}
      >
        <Typography variant="h3" mb={3} sx={{ color: "#70d8bd", textAlign: "center" }}>
          Configuration
        </Typography>

        {/* Email Field Row */}
        <Box mb={2} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ minWidth: 150 }}>Email Address:</Typography>
          <TextField
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter sender email"
            fullWidth
            variant="outlined"
            error={!!emailError}
            helperText={emailError}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                "& fieldset": { border: "1px solid #ccc" },
                "&:hover fieldset": { border: "1px solid #ccc" },
                "&.Mui-focused fieldset": { border: "1px solid #ccc" },
              },
            }}
          />
        </Box>

        {/* Send Email URL Field Row */}
        {/* Send Email URL Field */}
        <Box mb={2} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ minWidth: 150 }}>Send Email URL:</Typography>
          <TextField
            type="text"
            value={sendEmailUrl}
            onChange={(e) => setSendEmailUrl(e.target.value)}
            placeholder="Enter email service URL"
            fullWidth
            variant="outlined"
            InputProps={{
              sx: {
                borderRadius: '8px',
                backgroundColor: 'transparent',
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                '& fieldset': { border: '1px solid #ccc' },
                '&:hover fieldset': { border: '1px solid #ccc' },
                '&.Mui-focused fieldset': { border: '1px solid #ccc' },
              },
            }}
          />
        </Box>

        <Box mb={2} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ minWidth: 150 }}>website URL:</Typography>
          <TextField
            type="text"
            value={website}
            onChange={(e) => setwebsite(e.target.value)}
            placeholder="Enter website URL"
            fullWidth
            variant="outlined"
            InputProps={{
              sx: {
                borderRadius: '8px',
                backgroundColor: 'transparent',
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                '& fieldset': { border: '1px solid #ccc' },
                '&:hover fieldset': { border: '1px solid #ccc' },
                '&.Mui-focused fieldset': { border: '1px solid #ccc' },
              },
            }}
          />
        </Box>
        <Box mb={2} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ minWidth: 150 }}>EMS URL:</Typography>
          <TextField
            type="text"
            value={emsUrl}
            onChange={(e) => setEmsUrl(e.target.value)}
            placeholder="Enter EMS base URL"
            fullWidth
            variant="outlined"
            InputProps={{
              sx: {
                borderRadius: '8px',
                backgroundColor: 'transparent',
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                '& fieldset': { border: '1px solid #ccc' },
                '&:hover fieldset': { border: '1px solid #ccc' },
                '&.Mui-focused fieldset': { border: '1px solid #ccc' },
              },
            }}
          />
        </Box>

        {/* Save Button */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              backgroundColor: "green",
              width: "120px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "green", // Prevent color change on hover
              },
            }}
          >
            Save
          </Button>
        </Box>


        {/* Status Message */}
        {statusMessage && (
          <Box mt={2} sx={{ textAlign: "center" }}>
            <Typography variant="body2" color="success.main">
              {statusMessage}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>

  );
}

export default Config;